import { GlobalState } from '../../reducers';
import { FetchStatus } from '../../types/types';

export const getFilesFetchStatus = (state: GlobalState): FetchStatus =>
  state.files.fetchStatus;
